import React from 'react'
import { CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons'
import { Button, Spin } from 'antd'
import styled from 'styled-components'
import { useNetwork } from 'wagmi'

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />
const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const ValidatorCreation = styled.p`
  margin: 0;
  margin-top: 46px;
  font-weight: 500;
  font-size: 38px;
  line-height: 46px;
`

const TransactionWrapper = styled.p`
  margin: 0;
  margin-top: 25px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
`
const ErrMessage = styled.p`
  margin: 24px 0 24px 0;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
`
const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
interface ILoading {
  tx: ITransaction
  error?: string
  loadingText?: string
  errorText?: string
  resetState?: () => void
}
export interface ITransaction {
  hash: string
  type: number
  accessList: any[]
  blockHash: null
  blockNumber: null
  transactionIndex: null
  confirmations: number
  from: string
  gasPrice: GasLimit
  maxPriorityFeePerGas: GasLimit
  maxFeePerGas: GasLimit
  gasLimit: GasLimit
  to: string
  value: GasLimit
  nonce: number
  data: string
  r: string
  s: string
  v: number
  creates: null
  chainId: number
}

interface GasLimit {
  type: string
  hex: string
}

export const Loading = ({
  tx,
  error,
  resetState,
  loadingText,
  errorText,
}: ILoading) => {
  const { chain } = useNetwork()
  return (
    <LoadingWrapper>
      {!error ? (
        <Spin indicator={antIcon} />
      ) : (
        <CloseCircleOutlined style={{ fontSize: 80, color: '#FF0900' }} />
      )}
      <ValidatorCreation>{!error ? loadingText : errorText}</ValidatorCreation>
      {error && (
        <ErrMessage>Validators cannot be created at this moment. You can</ErrMessage>
      )}
      {error && (
        <ButtonsWrapper>
          <Button type="primary" onClick={resetState}>
            Try Again
          </Button>
          <p style={{ margin: 0, marginRight: 24, marginLeft: 24 }}>Or</p>
          <a href="mailto:support@gateway.fm">
            <Button>Reach our support</Button>
          </a>
        </ButtonsWrapper>
      )}
      {tx?.hash && (
        <TransactionWrapper>
          Transaction:{' '}
          <a
            href={`${chain.blockExplorers.default.url}/tx/${tx.hash}`}
            target="_blank"
            rel="noreferrer"
          >
            {tx.hash}
          </a>
        </TransactionWrapper>
      )}
    </LoadingWrapper>
  )
}
